import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Blocks the customer/supplier portal until activated_at is set.
 * /customer/activate and /supplier/activate render the activation form
 * itself, so we never redirect away from those paths.
 */
export default function ActivationGate({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return children;
  if (user.role === 'admin') return children;
  const needs = !user.activated_at;
  const target = user.role === 'supplier' ? '/supplier/activate' : '/customer/activate';
  if (needs && location.pathname !== target) return <Navigate to={target} replace />;
  return children;
}
